export default __webpack_public_path__ + "static/media/le_croise10.3f35e267.jpg";